import { TextInput } from '@mantine/core';
import { IFormInputSpecDeviceProperty } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a device property input.
 */
export default function DevicePropertyInputPreview({ spec }: { spec: IFormInputSpecDeviceProperty }) {
  return <TextInput required={spec.required} readOnly={spec.readOnly} size="sm" />;
}
